export const pizzalist = [
    {
        "id": "2-lou-malnatis-deep-dish-pizzas",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/97981/2-lou-malnatis-deep-dish-pizzas.bf0fe065d251a9cca3925b269d443a27.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Margarita Pizza",
        "dsc": "2 Lou Malnati's Deep Dish Pizzas",
        "price": 7.9,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "23699-choose-your-own-thin-crust-pizza-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/89781/choose-your-own-thin-crust-pizza-4-pack.b928a2008eab50c65dc87e59b5952190.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Pepperoni Pizza",
        "dsc": "Choose Your Own Thin Crust Pizza - 4 Pack",
        "price": 14,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "choose-your-own-new-haven-style-pizza-6-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131840/choose-your-own-new-haven-style-pizza-6-pack.ab82828afc6172cdd4017556c15e36dd.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Hawaiian Apizza",
        "dsc": "New Haven-Style Pizza - 6 Pack (Choose Your Own)",
        "price": 6,
        "rate": 4,
        "country": "West Haven, CT"
    },
    {
        "id": "6-lou-malnatis-deep-dish-pizzas",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/106829/6-lou-malnatis-deep-dish-pizzas.f59993181da5d295668c8a6fb856055e.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Four cheese Pizza",
        "dsc": "6 Lou Malnati's Deep Dish Pizzas",
        "price": 10.9,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "wood-fired-pizzas-best-seller-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/106027/wood-fired-pizzas-best-seller-4-pack.1653bb05922ba153ac178f8365d27f6d.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Meat lover's Pizza",
        "dsc": "Wood Fired Pizzas Best Seller - 4 Pack",
        "price": 15,
        "rate": 5,
        "country": "Phoenix, AZ"
    },
    {
        "id": "236991-choose-your-own-deep-dish-pizza-3-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133398/choose-your-own-deep-dish-pizza-3-pack.4111791511244a4946bb5c9ad2c17da9.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Chicken alfredo pizza",
        "dsc": "Choose Your Own Deep Dish Pizza - 3 Pack",
        "price": 14,
        "rate": 5,
        "country": "Chicago, IL"
    },
    {
        "id": "choose-your-own-detroit-style-pizza-3-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/132973/detroit-style-pizza-choose-your-own-3-pack.6b6f4909ffd4066d5471e70eac5c3d89.jpeg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Barbecue pork pizza",
        "dsc": "Detroit-Style Pizza - Choose Your Own 3 Pack",
        "price": 9,
        "rate": 4,
        "country": "Brooklyn, NY"
    },
    {
        "id": "brooklyn-pizza-choose-your-own-5-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/104938/brooklyn-pizza-choose-your-own-5-pack.edc4f476a75207d0af840ce6f225f2b3.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Prosciutto pizza",
        "dsc": "Brooklyn Pizza - Choose Your Own 5 Pack",
        "price": 16,
        "rate": 4,
        "country": "Albany, NY"
    },
    {
        "id": "choose-your-own-chicago-deep-dish-pizza-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/89948/chicago-deep-dish-pizza-4-pack.49927daafa8c147fe9bb2a113e56668e.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Tandoori chicken pizza",
        "dsc": "Chicago Deep Dish Pizza - 4 Pack",
        "price": 15,
        "rate": 5,
        "country": "Chicago, IL"
    },
    {
        "id": "4-lou-malnatis-deep-dish-pizzas",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/106828/4-lou-malnatis-deep-dish-pizzas.8c79eb7506b5752ab3387d8174246b17.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Mexican",
        "dsc": "4 Lou Malnati's Deep Dish Pizzas",
        "price": 9,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "tonys-custom-pizza-3-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131555/choose-your-own-pizza-3-pack.fcf7a43e38593007ef2857fe16d6dd26.png?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Seafood",
        "dsc": "Choose Your Own Pizza - 3 Pack",
        "price": 11,
        "rate": 5,
        "country": "San Francisco, CA"
    },
    {
        "id": "plain-thin-crust-pizza-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/115101/plain-thin-crust-pizza-4-pack.5540e9d166db2f0853643c6517e4a225.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Vegetarian  Pizza",
        "dsc": "Plain Thin Crust Pizza - 4 Pack",
        "price": 6,
        "rate": 5,
        "country": "Montville, NJ"
    },
    {
        "id": "brooklyn-pizza-choose-your-own-10-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/104883/brooklyn-pizza-choose-your-own-10-pack.7ddeb3b5b599ec9c7b1befcc9c14a1c0.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Paesan’s Pizza",
        "dsc": "Brooklyn Pizza - Choose Your Own 10 Pack",
        "price": 11,
        "rate": 4,
        "country": "Albany, NY"
    },
    {
        "id": "new-haven-style-mozzarella-pizza-6-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/132144/new-haven-style-mozzarella-pizza-6-pack.8e8a38db57935f5cb6afa4202b966135.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Mushroom Apizza",
        "dsc": "New Haven-Style Mozzarella Pizza - 6 Pack",
        "price": 8,
        "rate": 5,
        "country": "West Haven, CT"
    },
    {
        "id": "choose-your-own-3-pizzas",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133289/choose-your-own-3-pizzas.a6de480878c0b3b9f4d240bacbb665e7.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Mediterranean Pizza",
        "dsc": "Choose Your Own - 3 Pizzas",
        "price": 6,
        "rate": 4,
        "country": "Milaca, MN"
    },
    {
        "id": "15464-detroit-style-pizza-squares-choose-your-own-3-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/112202/detroit-style-pizza-squares-choose-your-own-3-pack.75f7714d9a81fb455f7400086e4195bf.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Capricciosa Pizza",
        "dsc": "Detroit-Style Pizza Squares - Choose Your Own 3 Pack",
        "price": 11,
        "rate": 4,
        "country": "Detroit, MI"
    },
    {
        "id": "15952-create-your-own-pizza-3-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133262/choose-your-own-pizza-3-pack.7ee3cc9bbc48b97a0f66e073d4071982.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Quattro stagioni",
        "dsc": "Detroit Pizza - Choose Your Own Pizza 3 Pack",
        "price": 8.5,
        "rate": 4,
        "country": "Detroit, MI"
    },
    {
        "id": "pan-style-deep-dish-pizza-choose-your-own-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/137057/Pequods-CYO-4-Pack-Product.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Neapolitan Pizza",
        "dsc": "Pan-Style Deep Dish Pizza - Choose Your Own 4 Pack",
        "price": 7,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "buffalo-style-pepperoni-pizza-2-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133315/buffalo-style-pepperoni-pizza-2-pack.38d99af16bc34554992bbed53870e533.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Calzone Pizza",
        "dsc": "Buffalo Style Pepperoni Pizza - 2 Pack",
        "price": 9,
        "rate": 5,
        "country": "Buffalo, NY"
    },
    {
        "id": "neapolitan-pizza-choose-your-own-3-Pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/119426/neapolitan-pizza-choose-your-own-3-pack.dada483ad51fe8e1f8b06c68a8f1356f.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Motorino Pizzeria",
        "dsc": "Neapolitan Pizza - Choose Your Own 3 Pack",
        "price": 11,
        "rate": 4,
        "country": "New York, NY"
    },
    {
        "id": "16940-brick-oven-pizza-6-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/71222/wood-fired-pizza-6-pack.1124121a87723161fcd034de9256cd22.png?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Roberta's Pizza",
        "dsc": "Wood Fired Pizza 6 Pack",
        "price": 7,
        "rate": 5,
        "country": "Brooklyn, NY"
    },
    {
        "id": "thin-crust-pizza-choose-your-own-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/118791/thin-crust-pizza-choose-your-own-4-pack.c9d8f813e752cb2a77b93e02752c5daf.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Bill's Pizza & Pub",
        "dsc": "Thin Crust Pizza - Choose Your Own 4 Pack",
        "price": 7,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "ny-style-pizza-choose-your-own-3-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/132421/ny-style-pizza-choose-your-own-3-pack.6364a762aa92bd037cc1519037680fef.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Rubirosa Pizza",
        "dsc": "NY Style Pizza - Choose Your Own 3 Pack",
        "price": 11,
        "rate": 4,
        "country": "New York, NY"
    },
    {
        "id": "choose-your-own-chicago-deep-dish-pizza-2-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/89920/chicago-deep-dish-pizza-2-pack.258bfa1979e758e45ffc2c93043540e5.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "My Pi Pizza",
        "dsc": "Chicago Deep Dish Pizza - 2 Pack",
        "price": 11,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "pizza-choose-your-own4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131566/pizza-choose-your-own-4-pack.92a5ef9f5f219eb870cf7e909656545d.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Regina Pizzeria",
        "dsc": "Pizza - Choose Your Own 4 Pack",
        "price": 11,
        "rate": 4,
        "country": "Boston, MA"
    },
    {
        "id": "2-lou-malnatis-deep-dish-pizzas-lezza-chocolate-cake",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/106830/2-lou-malnatis-deep-dish-pizzas-lezza-chocolate-cake.f791b76ca45f684a6c0512aa4aec56aa.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Lou Malnati's Pizza",
        "dsc": "2 Lou Malnati's Deep Dish Pizzas + Lezza Chocolate Cake",
        "price": 10.5,
        "rate": 4,
        "country": "Chicago, IL"
    },
    {
        "id": "thin-crust-pizza-choose-your-own-6-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/116162/thin-crust-pizza-choose-your-own-6-pack.9d724e00f69d761845f7edf0f66698d2.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "The Columbia Inn",
        "dsc": "Thin Crust Pizza - Choose Your Own 6 Pack",
        "price": 11,
        "rate": 5,
        "country": "Montville, NJ"
    },
    {
        "id": "neapolitan-pizza-choose-your-own-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131291/neapolitan-pizza-choose-your-own-4-pack.e9e370c647523cb3b6a8ee6f60c9a9c1.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Pizzeria Delfina",
        "dsc": "Neapolitan Pizza - Choose Your Own 4 Pack",
        "price": 7,
        "rate": 5,
        "country": "San Francisco, CA"
    },
    {
        "id": "Sausage-pizza-6-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133501/sausage-pizza-6-pack.31fa94213da11ab58951fcc7838f6754.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Zuppardi's Apizza",
        "dsc": "New Haven-Style Sausage Pizza - 6 Pack",
        "price": 6,
        "rate": 5,
        "country": "West Haven, CT"
    },
    {
        "id": "original-cheese-new-york-pizza-2-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/104910/cheese-neapolitan-pizza-2-pack.856b6b14d276981a4654e1bb348cb328.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Joe & Pats Pizzeria",
        "dsc": "Original Cheese New York Pizza - 2 Pack",
        "price": 6,
        "rate": 4,
        "country": "Staten Island, NY"
    },
    {
        "id": "choose-your-own-bar-pizza-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133147/choose-your-own-bar-pizza-4-pack.2576e0f60267c680022bd3466542bb9e.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Cape Cod Cafe Pizza",
        "dsc": "Bar Pizza - 4 Pack - Choose Your Own",
        "price": 9,
        "rate": 5,
        "country": "Brockton, MA"
    },
    {
        "id": "16939-brick-oven-pizza-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/71231/wood-fired-pizza-4-pack.8818b2e71ad1149790d0c03413d11996.png?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Roberta's Pizza",
        "dsc": "Wood Fired Pizza 4 Pack",
        "price": 9,
        "rate": 4,
        "country": "Brooklyn, NY"
    },
    {
        "id": "signature-sampler",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/134789/signature-sampler-serves-10.2d7375635d9152e3401a0daacd40f648.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Bonci Pizza",
        "dsc": "Signature Pizza Sampler - Serves 10",
        "price": 15,
        "rate": 5,
        "country": "Chicago, IL"
    },
    {
        "id": "pan-style-deep-dish-pizza-choose-your-own-2-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/137018/Pequods-CYO-2-Pack-Product.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Pequod's Pizza",
        "dsc": "Pan-Style Deep Dish Pizza - Choose Your Own 2 Pack",
        "price": 13,
        "rate": 5,
        "country": "Chicago, IL"
    },
    {
        "id": "wood-fired-pizza-choose-your-own-2-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133839/pizza-choose-your-own-2-pack.0820d0d4642ddb9fbda63e2394b63932.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Arthur Avenue Wood Fired Pizza",
        "dsc": "Wood Fired Pizza - Choose Your Own 2 Pack",
        "price": 13,
        "rate": 5,
        "country": "Pleasantville, NY"
    },
    {
        "id": "chicago-style-pizza-buy-3-get-1-free",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/135044/chicago-style-pizza-choose-your-own-3-pack.c97386b561818a977030178b06fa5bda.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Sam's Coal Fired Pizza",
        "dsc": "Chicago Style Pizza - Buy 3 + Get 1 FREE Cheese Pizza",
        "price": 11,
        "rate": 5,
        "country": "Daytona Beach, FL"
    },
    {
        "id": "neapolitan-pizza-choose-your-own-6-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131875/wood-fired-pizza-choose-your-own-6-pack.fa6cf8ffff1241d50c27d804e566d605.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Pasquale Jones",
        "dsc": "Neapolitan Pizza - Choose Your Own 6 Pack",
        "price": 15,
        "rate": 5,
        "country": "New York, NY"
    },
    {
        "id": "wood-fired-pizza-choose-your-own-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/104006/wood-fired-pizza-choose-your-own-4-pack.e36692807e17618a646885a8087a4c97.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Pizzeria Bianco",
        "dsc": "Wood Fired Pizza - Choose Your Own 4 Pack",
        "price": 13,
        "rate": 5,
        "country": "Phoenix, AZ"
    },
    {
        "id": "buffalo-style-pepperoni-pizza-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131666/buffalo-style-pepperoni-pizza-4-pack.1c5ea10d8c7176f0ad4eef363a1f3543.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Picasso's Pizza",
        "dsc": "Buffalo Style Pepperoni Pizza - 4 Pack",
        "price": 14,
        "rate": 4,
        "country": "Buffalo, NY"
    },
    {
        "id": "15318-make-your-own-old-forge-pizza-2-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/67763/make-your-own-old-forge-pizza-2-pack.f7cd011e9c2ac3182dbe1e3470985354.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Arcaro & Genell",
        "dsc": "Make Your Own Old Forge Pizza 2 Pack",
        "price": 9,
        "rate": 4,
        "country": "Old Forge, PA"
    },
    {
        "id": "pizza-choose-your-own-4-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/134259/pizza-choose-your-own-4-pack.bc138c4f695f74bf78f13204865a9c5b.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Slim & Husky's",
        "dsc": "Pizza - Choose Your Own 4 Pack",
        "price": 11,
        "rate": 5,
        "country": "Nashville, TN"
    },
    {
        "id": "spicy-spring-2-pack",
        "img": "https://goldbelly.imgix.net/uploads/product_image/image/61943/spicy-spring-2-pies-serves-16.fd9e6f0fce7306a15ec794b7d91f7056.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Prince Street Pizza",
        "dsc": "Spicy Spring™ - 2 Pies (Serves 16)",
        "price": 10.5,
        "rate": 5,
        "country": "New York, NY"
    },
    {
        "id": "cheese-pizza-5-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/134099/cheese-pizza-5-pack.e22243aba836daa325ee1b563fc2ca36.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Paesan’s Pizza",
        "dsc": "Classic Cheese Pizza - 5 Pack",
        "price": 16,
        "rate": 5,
        "country": "Albany, NY"
    },
    {
        "id": "detroit-style-pizza-best-seller-3-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131672/detroit-style-pizza-best-seller-3-pack.f56562a340b3ada0a8a571fa80020304.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Emmy Squared",
        "dsc": "Detroit-Style Pizza - Best Seller 3 Pack",
        "price": 9,
        "rate": 4,
        "country": "Brooklyn, NY"
    },
    {
        "id": "famous-pizza-making-kit",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/134230/famous-pizza-making-kit.74d1d16b7fa71a2acbd36f825d84d75b.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Tony Boloney's",
        "dsc": "Famous Pizza Making Kit",
        "price": 9,
        "rate": 5,
        "country": "Hoboken, NJ"
    },
    {
        "id": "famous-artichoke-pizza-2-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/80601/artichoke-basilles-pizza-2-pack.3e8f5b94405720ed1c0ef2765c5b0669.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Artichoke Basille's Pizza",
        "dsc": "Famous Artichoke Pizza - 2 Pack",
        "price": 7,
        "rate": 4,
        "country": "New York, NY"
    },
    {
        "id": "brooklyn-pizza-best-seller-5-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131936/brooklyn-pizza-best-seller-5-pack.8434f2ef7ad80ef2c5bef19f1ecb94ba.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Paesan’s Pizza",
        "dsc": "Brooklyn Pizza Best Seller - 5 Pack",
        "price": 16,
        "rate": 5,
        "country": "Albany, NY"
    },
    {
        "id": "neapolitan-pizza-choose-your-own-3-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/114414/neapolitan-pizza-choose-your-own-3-pack.5b29cea22f1eeee4b8d95057b9bc7abd.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Pizzeria Delfina",
        "dsc": "Neapolitan Pizza - Choose Your Own 3 Pack",
        "price": 11,
        "rate": 5,
        "country": "San Francisco, CA"
    },
    {
        "id": "pepperoni-ny-style-pizza-2-pack",
        "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/108219/pepperoni-ny-style-pizza-2-pack.77685b4dbd4cea75fa8e8b8ac59ba2b5.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
        "name": "Rubirosa Pizza",
        "dsc": "Pepperoni NY Style Pizza - 2 Pack",
        "price": 9,
        "rate": 5,
        "country": "New York, NY"
    }
]